import { Injectable } from '@angular/core';
import { ApiRequestsService } from '@base/api/api.gateway';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from '@base/shared/services';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  private _currentId: String = localStorage.getItem('eryus-currentProject') || '';
  private _currentDailyLog: String = localStorage.getItem('eyrus-dailylog') || null;
  private _contractDefinitionId: String = localStorage.getItem('eyrus-contractDefinitionId') || null;
  private _currentTask: String = JSON.parse(localStorage.getItem('eyrus-task') || '{}') || {};
  private _currenNote: String = JSON.parse(localStorage.getItem('eyrus-note') || '{}') || {};
  private _currentProject: String = JSON.parse(localStorage.getItem('eyrus-current-project') || '{}') || {};
  private _currentContract: String = JSON.parse(localStorage.getItem('eyrus-current-contract') || '{}') || {};
  private _dailyLogDate: String = localStorage.getItem('eyrus-dailylog-date') || null;
  private _projectName: String = localStorage.getItem('eyrus-project-name') || '';

  constructor(
    private api: ApiRequestsService,
    private route: ActivatedRoute,
    private helpers: HelpersService
  ) { }

  set projectId(id: any) {
    localStorage.setItem('eryus-currentProject', id);
    this._currentId = id;
  }

  get projectId() {
    return this._currentId;
  }

  set dailyLog(id: any) {
    localStorage.setItem('eyrus-dailylog', id);
    this._currentDailyLog = (id === 'null' ? null : id) || null;
  }

  get dailyLog() {
    const id = localStorage.getItem('eyrus-dailylog');
    return (id === 'null' ? null : id) || null;
  }

  set contractDefinitionId(id: any) {
    localStorage.setItem('eyrus-contractDefinitionId', id);
    this._contractDefinitionId = (id === 'null' ? null : id) || null;
  }

  get contractDefinitionId() {
    const id = localStorage.getItem('eyrus-contractDefinitionId');
    return (id === 'null' ? null : id) || null;
  }

  get dailyLogDate() {
    return (this._dailyLogDate === 'null' ? null : this._dailyLogDate) || null;
  }

  set dailyLogDate(_date: any) {
    localStorage.setItem('eyrus-dailylog-date', _date);
    this._dailyLogDate = (_date === 'null' ? null : _date) || null;
  }

  set currentProject(project: any) {
    localStorage.setItem('eyrus-current-project', JSON.stringify(project));
    this._currentProject = project;
  }

  get currentProject() {
    return this._currentProject;
  }

  set currentContract(project: any) {
    localStorage.setItem('eyrus-current-contract', JSON.stringify(project));
    this._currentContract = project;
  }

  get currentContract() {
    return this._currentContract;
  }

  set currentTask(task: any) {
    localStorage.setItem('eyrus-task', JSON.stringify(task));
    this._currentTask = task;
  }

  get currentTask() {
    return this._currentTask;
  }

  set currenNote(task: any) {
    localStorage.setItem('eyrus-note', JSON.stringify(task));
    this._currenNote = task;
  }

  get currentNote() {
    return this._currenNote;
  }

  get projectName() {
    return this._projectName;
  }

  set projectName(name: any) {
    localStorage.setItem('eyrus-project-name', name);
    this._projectName = name;
  }

  /**
   * Check if daily log exists and create a new one if not
   * @param calendarDate Daily log calendar date
   */
  createDailyLog() {
    return new Promise((resolve, reject) => {
      if (this.dailyLog) {
        return resolve(
          {
            result: true,
            dailyLog: {
              dailyLogId: this._currentDailyLog,
              statusTypeId: this.currentProject.statusTypeId || 1
            }
          }
        );
      }

      const payload = {
        contractDefinitionId: this.route.snapshot.queryParams.contractDefinitionId || this.contractDefinitionId,
        calendarDate: this.route.snapshot.queryParams.calendarDate || this.dailyLogDate
      };

      this.api.dailyLogs.createDailyLog(payload).toPromise()
        .then(res => {
          this.dailyLog = res.dailylogId;
          resolve(res);
        })
        .catch(err => {
          this.helpers.errorMessage(err);
          reject(err)
        });
    });
  }
}
